import { Icon } from "antd";
import React from "react";

export const LoadingSpinner = (
  <Icon type="loading" style={{ fontSize: 24 }} spin />
);
